<template>
    <CCard>
        <CCardBody>
            <h5 class="text-primary">Placement Type</h5>
                   <GPie v-if="placementTypeChartData.length" :data="placementTypeChartData" :keys="keys"/>

        </CCardBody>
    </CCard>
</template>
<script>
import GPie from "@/components/reusable/Charts/GPie.vue";
import clinicalData from "@/containers/ClinicalPlacementDashboard/clinicalData.json";
export default {
  name: "PlacementTypeChart",
  components: {
    GPie,
  },
  computed: {
    placementTypeChartData() {
      const count = clinicalData.reduce((acc, item) => {
        if (!acc[item["Placement Type"]] ) {
          acc[item["Placement Type"]] = 0;
        }
        acc[item["Placement Type"]]++;
        return acc;
      }, {});
      const counts = Object.entries(count).map(([placmentType, count], index) => ({
        name: placmentType,
        value: count,
        backgroundColor: "#b1a5d6",
        borderColor: "#b1a5d6",
      }));
      return counts;
    },
    keys() {
      return ["Placement Type", "Count"];
    },
  }
};
</script>
<style scoped></style>
